import { z } from 'zod';

const AllowanceSchema = z.object({
  usageType: z.string(),
  used: z.number(),
  recurring: z.number(),
  individual: z.number(),
  resetValue: z.number(),
  unlimited: z.boolean(),
  notAllowed: z.boolean(),
  total: z.number(),
  remaining: z.number(),
});

export const EntitlementResponseSchema = z.object({
  key: z.string(),
  available: z.boolean(),
  allowed: z.boolean(),
  // no allowance is returned for cancelled accounts
  allowance: AllowanceSchema.optional(),
  reasons: z.array(z.string()),
  bridge: z.boolean(),
  expirationDate: z.string().nullable(),
});

export type EntitlementResponse = z.infer<typeof EntitlementResponseSchema>;
